import { css } from 'styled-components'

export const containerExpanded = css`
  width: 90vw;
  max-width: 80vw;

  @media (max-width: 992px) {
    width: 90vw;
  }

  @media (max-width: 640px) {
    width: 95vw;
  }
`

export const containerDefault = css`
  width: 90vw;
  max-width: 80vw;

  @media (max-width: 992px) {
    width: 88vw;
  }

  @media (max-width: 480px) {
    width: 95vw;
  }
`

export const containerNarrow = css`
  width: 75vw;
  max-width: 44rem;

  @media (max-width: 992px) {
    width: 70vw;
  }

  @media (max-width: 640px) {
    width: 90vw;
  }
`

export const containerHeadlineLarge = css`
  width: 80vw;
  max-width: 36rem;

  @media (max-width: 992px) {
    width: 85vw;
  }

  @media (max-width: 640px) {
    width: 90vw;
  }
`

export const containerHeadline = css`
  width: 80vw;
  max-width: 32rem;

  @media (max-width: 992px) {
    width: 85vw;
  }

  @media (max-width: 640px) {
    width: 90vw;
  }
`

export const containerContent = css`
  ${containerHeadline};
  margin: auto;
`

export const defaultBorderWithRadius = css`
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.black[3]};
  border-radius: 1rem;
`
